import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-span',
  templateUrl: './st-span.component.html',
  styleUrls: ['./st-span.component.scss'],
  standalone: false
})
export class StSpanComponent {

  @Input()
  inputVal: string = '';
}
